import { SlideFade, VStack, Box, BoxProps } from '@chakra-ui/react'
import { navigate } from 'gatsby'
import * as React from 'react'

import ButtonHamburger from '../buttons/ButtonHamburger'
import ButtonLanguage from '../buttons/ButtonLanguage'
import Image from '../common/Image'
import NavPCLink from './NavPCLink'
import useLocale from '../../hooks/useLocale'
import { changeLocale } from 'gatsby-plugin-intl'

const isBrowser = () => typeof location !== 'undefined'

export type NavPCProps = BoxProps & {}

const NavPC: React.FC<NavPCProps> = ({ ...others }) => {
  const [isOpen, setIsOpen] = React.useState(false)

  const handleClick = () => {
    setIsOpen(false)
  }
  const { isEn } = useLocale()
  const setLanguage = async (prefix: string) => {
    if (prefix === 'ja') {
      const path = isBrowser() ? location.pathname : '/'
      const to = path.replace(/^.*?\/en/, '')
      console.log('hoge', path, to)
      await navigate(to)
    } else {
      changeLocale(prefix)
    }
    handleClick()
  }

  return (
    <>
      <Box pos="relative" {...others}>
        <ButtonHamburger
          pos="fixed"
          zIndex="99999"
          top="6px"
          left="0"
          isOpen={isOpen}
          onClick={() => setIsOpen(!isOpen)}
        />

        <SlideFade
          in={isOpen}
          unmountOnExit={true}
          w="100%"
          h="100%"
          offsetX="-400px"
          transition={{
            enter: { duration: 0.25 },
          }}
        >
          <Box
            w="400px"
            minH="100vh"
            bg="black"
            css={{
              a: {
                textDecoration: 'none',
              },
            }}
          >
            <Box p="33px 29px 58px" textAlign="right">
              <ButtonLanguage localizeKey="nav__global__ja" disabled={!isEn} onClick={() => setLanguage('ja')} />
              {' / '}
              <ButtonLanguage localizeKey="nav__global__en" disabled={isEn} onClick={() => setLanguage('en')} />
            </Box>
            <Box m="0 0 47px 80px">
              <Image src="/images/logo.png" w="156px" h="156px" />
            </Box>
            <VStack ml="80px" spacing="33px" alignItems="flex-start">
              <NavPCLink to="/" localizeKey="nav__global__top" onClick={handleClick} />
              <NavPCLink to="/artists/" localizeKey="nav__global__artists" onClick={handleClick} />
              <NavPCLink to="/event/" localizeKey="nav__global__event" onClick={handleClick} />
              <NavPCLink to="/ticket/" localizeKey="nav__global__ticket" onClick={handleClick} />
              <NavPCLink to="/about/" localizeKey="nav__global__about" onClick={handleClick} />
              <NavPCLink to="/access/" localizeKey="nav__global__access" onClick={handleClick} />
            </VStack>
          </Box>
        </SlideFade>
      </Box>
    </>
  )
}

export default NavPC
